import { Button, Col, Form, Input, Row } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { IFormProps } from '../../../typings';

export interface ConfirmFormProps extends IFormProps {
  resendConfirmationCode: () => Promise<void>;
  resendCodeLoading: boolean;
}

export const ConfirmForm = ({ loading, resendConfirmationCode, resendCodeLoading, ...rest }: ConfirmFormProps) => {
  const { t } = useTranslation();

  return (
    <Form layout="vertical" {...rest}>
      <Form.Item label={t('CONFIRMATION_CODE_LABEL')} name="code" labelCol={{ span: 24 }} rules={[{ required: true }]}>
        <Input autoComplete="off" />
      </Form.Item>
      <Form.Item>
        <Row justify="center">
          <Col span="24">
            <Button type="primary" loading={loading} disabled={resendCodeLoading} htmlType="submit" block>
              {t('CONFIRM_REGISTRATION_BUTTON')}
            </Button>
          </Col>
          <Col span="24" style={{ paddingTop: '10px' }}>
            <Button
              type="primary"
              loading={resendCodeLoading}
              disabled={loading}
              block
              onClick={resendConfirmationCode}
            >
              {t('RESEND_CODE')}
            </Button>
          </Col>
          <Col style={{ padding: '10px 0' }}>
            <strong>{t('CONFIRM_REGISTRATION_FORM_TEXT')}</strong>
          </Col>
          <Col span="24">
            <Link to="/register">
              <Button type="primary" style={{ width: '100%' }}>
                {t('CREATE_ACCOUNT_BUTTON')}
              </Button>
            </Link>
          </Col>
        </Row>
      </Form.Item>
    </Form>
  );
};
